





















import {Component, Prop, Vue} from "vue-property-decorator";
import format from "@/valchrom/views/dataset/NumberFormat";
import DecisionIconButtonComponent from "@/valchrom/views/dataset/DecisionIconButtonComponent.vue";

class Decision {
    name ?: string;
    limit ?: string;
    found ?: string;
    passed ?: Boolean;
}

@Component({
    components: {
        DecisionIconButtonComponent
    }
})
export default class NewCriteriaTable extends Vue {
    @Prop() decisions ?: Decision;

    getData(){
        return this.decisions;
    }

    activeColumns() {
        return [
            {
                key: "name",
                title: "Criteria"
            },{
                key: "limit",
                title: "Limit"
            },{
                key: "found",
                title: "Found"
            },{
                key: "passed",
                title: "Decision"
            }
        ];
    }
}
